import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ListBox = (props) => {
  // default
  // current
  // options
  const [selected, setSelected] = useState(
    props.default ? props.default : props.current
  );
  const handleChange = (e) => {
    setSelected(e);
    props._handleSelected(e);
  };

  return (
    <Listbox value={selected} onChange={(e) => handleChange(e)}>
      {({ open }) => (
        <div className={"py-2 " + props.className}>
          <label className="text-left pl-2 text-gray-700 dark:text-gray-200">
            {props.label}
          </label>
          <Listbox.Button className="flex flex-row justify-around overflow-y-hidden h-10 bg-white w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            <label className="">{selected}</label>
            <SelectorIcon
              className="flex-shrink h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </Listbox.Button>

          <Transition
            show={open}
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-30 mt-1 w-56 overflow-y-auto overflow-x-hidden bg-white shadow-lg max-h-56 rounded-md py-2 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {props.options.map((option) => (
                <Listbox.Option
                  className={({ active }) =>
                    classNames(
                      active ? "text-white bg-indigo-600" : "text-gray-900",
                      "cursor-pointer select-none relative py-2 pl-3 pr-9"
                    )
                  }
                  value={option}
                >
                  <label
                    className={classNames(
                      selected ? "font-semibold " : "font-normal",
                      "flex"
                    )}
                  >
                    {option}
                  </label>
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
};

export default ListBox;
